// extracted by mini-css-extract-plugin
export default {"main":"plan-contribution-pay-pending-card_main__FXeh8","disabled":"plan-contribution-pay-pending-card_disabled__d7d1X"};